import React from "react";
import { PageHeader } from "@/components/ui-blocks/PageHeader";
import { SEO } from "@/lib/seo";
import { Link } from "react-router-dom";
import { Newspaper, Radio, Camera, Mail, FileText, Video } from "lucide-react";

const LINKS = [
  { to: "/press-releases", title: "Press Releases", desc: "Official CAF releases and media statements.", Icon: Newspaper },
  { to: "/video-library", title: "Video Library", desc: "Impact reels and awareness films.", Icon: Video },
  { to: "/blog", title: "News & Blog", desc: "Field updates and transparency briefs.", Icon: Radio },
  { to: "/events", title: "Events", desc: "Upcoming, ongoing and past events.", Icon: Camera },
  { to: "/annual-reports", title: "Annual Reports", desc: "Audited annual reports and impact data.", Icon: FileText },
];

export default function MediaCentrePage() {
  return (
    <main>
      <SEO title="Media Centre" description="CAF Media Centre — press releases, videos, events and journalist resources." breadcrumbs={[{name: "Home", href:"/"},{name:"Media Centre", href:"/media"}]} />
      <PageHeader eyebrow="Media Centre" title="Resources for journalists and editors." lead="Media enquiries, press releases, high-resolution imagery, and interview requests." />
      <section className="container-wide py-12 grid gap-5 md:grid-cols-2 lg:grid-cols-3">
        {LINKS.map((l) => (
          <Link key={l.to} to={l.to} data-testid={`media-link-${l.to}`} className="group rounded-2xl border border-border bg-background p-6 card-lift">
            <div className="h-10 w-10 rounded-md bg-[hsl(var(--surface-tint))] text-foreground grid place-items-center"><l.Icon className="h-5 w-5" /></div>
            <h3 className="heading-3 mt-3 text-lg group-hover:text-[hsl(var(--orange))]">{l.title}</h3>
            <p className="text-sm text-[hsl(var(--muted-ink))] mt-2">{l.desc}</p>
          </Link>
        ))}
      </section>
      <section className="container-wide pb-12">
        <div className="rounded-2xl border border-border bg-[hsl(var(--surface-tint))] p-6 flex items-center gap-3">
          <Mail className="h-5 w-5 text-[hsl(var(--orange))]" />
          <div className="text-sm text-foreground">Media enquiries: <a href="mailto:press@caf.org.in" className="font-semibold underline">press@caf.org.in</a></div>
        </div>
      </section>
    </main>
  );
}
